<template>
  <div
    id="onboarding"
    class="tw-flex tw-flex-col tw-justify-between"
    :class="{'tw-bg-[#F3F3F3]': isOnboardingRedesign && onboardingstep === 'upsell'}"
  >
    <b-container
      fluid
      :class="{'pl-0 pr-0': !isOnboardingRedesign, '!tw-p-0': isOnboardingRedesign, '!tw-px-0 tw-bg-[#F3F3F3]': isOnboardingRedesign && onboardingstep === 'upsell'}"
    >
      <transition name="fade">
        <IntermediaryLoader
          v-if="intermediaryLoader && loaderType == 2"
          loader-type="2"
        />
        <IntermediaryLoader
          v-if="intermediaryLoader && loaderType == 3"
          loader-type="3"
        />
        <IntermediaryLoader
          v-if="intermediaryLoader && loaderType == 1"
          loader-type="1"
          :quote="intermediaryLoaderText"
          :image="require('@/assets/images/onboarding/loader.png')"
        />
        <IntermediaryLoader
          v-if="intermediaryLoader && loaderType == 4"
          loader-type="1"
          quote="With Winona, feeling better is a few steps away."
          :image="require('@/assets/images/onboarding/loader1.png')"
        />
        <IntermediaryLoader
          v-if="intermediaryLoader && loaderType == 5 && messageType == 'HIPAA'"
          loader-type="5"
          dark-bg
          @click="hideLoader"
        >
          <template #text>
            <p>
              Welcome to Winona! We are excited to get to help you on your
              menopause journey.
            </p>
            <p>
              Please start your brief online visit to confirm your interests,
              concerns, and goals. With this information, our medical team can
              send your personalized treatments directly from our Winona pharmacy
              to your home.
            </p>
            <p class="loader-highlight">
              All of your personal information is properly stored and protected by
              our HIPAA compliant medical information storage system.
            </p>
          </template>
        </IntermediaryLoader>
        <IntermediaryLoader
          v-if="
            intermediaryLoader &&
              loaderType == 5 &&
              messageType == 'doctorvisit' &&
              ['E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)
          "
          loader-type="5"
          dark-bg
          @click="hideLoader"
        >
          <template #text>
            <ul class="tw-mt-8">
              <li class="tw-text-lg tw-list-disc tw-mb-2">
                Your Winona doctor will review your answers and selected treatments.
              </li>
              <li class="tw-text-lg tw-list-disc tw-mb-2">
                If neither you nor your doctor have any questions or safety concerns, your prescription will be filled.
              </li>
              <li class="tw-text-lg tw-list-disc tw-mb-2">
                You can message with your doctor anytime through the Patient Portal.
              </li>
              <li class="tw-text-lg tw-list-disc tw-mb-2">
                No charges now — your card is only billed if a treatment plan is prescribed.
              </li>
            </ul>
          </template>
        </IntermediaryLoader>
        <IntermediaryLoader
          v-if="
            intermediaryLoader &&
              loaderType == 5 &&
              messageType == 'doctorvisit' &&
              !['E1', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)
          "
          loader-type="5"
          dark-bg
          @click="hideLoader"
        >
          <template #text>
            <p
              :class="isOnboardingRedesign
                ? 'tw-text-[#1A1A1A] tw-text-lg md:tw-text-[26px] lg:tw-text-[2rem] tw-leading-[20px] md:tw-leading-[28px] lg:tw-leading-[32px]'
                : 'loader-highlight'"
            >
              Your Winona doctor visit is free and includes unlimited follow-ups.
              Assuming there are no questions or concerns from you or the doctor,
              and the doctor feels the treatments selected are safe,
              the prescriptions will be filled. You’ll have the opportunity to
              message your doctor directly from the Patient Portal after
              onboarding is complete.
            </p>
            <p
              :class="isOnboardingRedesign &&
                'tw-text-[#1A1A1A] tw-text-lg md:tw-text-[26px] lg:tw-text-[2rem] tw-leading-[20px] md:tw-leading-[28px] lg:tw-leading-[32px]'"
            >
              Your card will not be charged at this time. However, by adding a
              payment method, you authorize Winona to charge your card upon a
              physician’s prescription of treatment. If you have any questions,
              please message your doctor in the Patient Portal or reach
              out to the Patient Care Team.
            </p>
          </template>
        </IntermediaryLoader>
        <IntermediaryLoader
          v-if="intermediaryLoader && loaderType == 6"
          loader-type="6"
          neutral-bg
        />
        <IntermediaryLoader
          v-if="
            intermediaryLoader &&
              loaderType == 5 &&
              messageType == 'doctormatching'
          "
          message-type="doctormatching"
          loader-type="5"
          side-text="DOCTOR CONSULTATION"
          :userid="userid"
          light-bg
          @click="hideLoader"
        >
          <template #text>
            <!-- <b-img fluid-grow class="pr-3" :src="require('@/assets/images/doctor_chat.png')" /> -->
            <b-row
              align-v="center"
              class="mt-5"
            >
              <b-col cols="auto">
                <!-- <b-img src="@/assets/images/onboarding/doctor.png" rounded="circle" alt="Circle image"></b-img> -->
                <b-avatar
                  :src="require('@/assets/images/onboarding/doctor.png')"
                  size="7rem"
                />
              </b-col>
              <b-col>
                <h2 class="mb-2 loader-text">
                  Dr. Michael Green, OB/GYN
                </h2>
                <p
                  class="mb-0 loader-sub-text"
                  style="color: #333333"
                >
                  CA License #: G80363
                </p>
              </b-col>
            </b-row>
            <p class="mt-5 text-default">
              <span
                class="med-font d-block mb-3"
              >You've been matched with Dr. Michael Green, a board certified,
                licensed, OB/GYN in California with over 28 years of experience in
                women's healthcare.</span>
            </p>
            <p class="text-default">
              He will help you review your treatment options and choose your
              prescription if suitable — he'll be available for as many follow-ups
              as you need.
            </p>
          </template>
        </IntermediaryLoader>

        <div
          id="fixed-header"
          class="tw-fixed tw-z-[1000] tw-w-full"
        >
          <template v-if="!isOnboardingRedesign">
            <FsaHsaStoreBanner />
          </template>
          <b-navbar
            v-if="!intermediaryLoader"
            toggleable="sm"
            :class="{
              'tw-flex tw-justify-between tw-z-[590]': true,
              'tw-m-0': $_fsaHsaPromo_isActiveFsaHsaPromo && isOnboardingRedesign,
              'tw-mt-[60px] md:tw-mt-[86px]': $_fsaHsaPromo_isActiveFsaHsaPromo && !isOnboardingRedesign,
              'tw-p-6 !tw-z-[1000] md:!tw-pl-[3rem]  lg:!tw-pl-[5rem]': isOnboardingRedesign,
              'tw-left-0 tw-w-full': !isOnboardingRedesign
            }"
          >
            <template v-if="isOnboardingRedesign">
              <div class="tw-flex tw-items-center tw-gap-2">
                <portal-target name="back" />
                <b-navbar-brand
                  class="c-logo relative tw-mb-0 tw-cursor-pointer md:tw-left-0 tw-pl-0"
                  @click="showRedirectModal = true"
                >
                  <img
                    src="@/assets/images/logo_v2.svg"
                    alt=""
                  >
                </b-navbar-brand>
              </div>
            </template>
            <template v-else>
              <b-navbar-brand
                to="/website"
                class="c-logo relative mb-2"
              >
                <img
                  src="@/assets/images/logo.svg"
                  alt=""
                >
              </b-navbar-brand>
              <b-button
                v-if="$route.path != '/eligibility'"
                pill
                variant="light"
                class="logout ml-auto mr-3 pa-2 tw-flex"
                @click="showLogoutModal = true"
              >
                <img
                  src="@/assets/images/logout.svg"
                  class="mr-2"
                >Logout
              </b-button>
            </template>
          </b-navbar>
          <portal-target name="onboarding-upsell-banner" />
          <template v-if="isOnboardingRedesign">
            <FsaHsaStoreBanner />
            <portal-target name="referral-banner" />
          </template>
          <portal-target name="discount-banner" />
          <portal-target name="product-reveal-banner" />
          <portal-target
            v-if="!isOnboardingRedesign"
            name="back"
          />
        </div>
      </transition>

      <vue-page-transition
        id="onboarding-router-view"
        :class="{
          'tw-mt-20' : !isOnboardingRedesign && $_fsaHsaPromo_isActiveFsaHsaPromo,
          'tw-pt-0 md:tw-pt-10 lg:tw-pt-0': !isOnboardingRedesign,
        }"
      >
        <router-view
          :title="title"
          @showLoader="showLoader"
          @hideLoader="hideLoader"
          @setOnboardingStep="setOnboardingStep"
          @showExitModal="showRedirectModal = true"
          @setExiting="setExiting"
        />
      </vue-page-transition>

      <!-- Redirect Modal -->
      <b-modal
        v-model="showRedirectModal"
        size="md"
        hide-header
        hide-footer
        centered
        :content-class="isOnboardingRedesign ? `tw-bg-white` : `dark-bg`"
        no-close-on-backdrop
        no-close-on-esc
        no-stacking
      >
        <div v-if="isOnboardingRedesign">
          <h2
            class="color-inherit tw-py-4 tw-text-center"
            style="font-size: 26px;"
          >
            Are you sure you want to quit onboarding?
          </h2>

          <div class="tw-max-w-[300px] tw-mx-auto">
            <b-button
              variant="info"
              class="slight-rounded"
              pill
              block
              @click="redirectToMarketing"
            >
              Yes, I'm Sure
            </b-button>
            <b-button
              variant="info"
              class="slight-rounded tw-bg-transparent tw-text-[#312849] hover:tw-bg-[#f5f3fc] tw-border-[#312849]"
              pill
              block
              @click="showRedirectModal = false"
            >
              Cancel
            </b-button>
          </div>
        </div>
        <template v-else>
          <b-row class="mb-6">
            <b-col cols="12">
              <div class="icon-logo dark"></div>
            </b-col>
          </b-row>
          <div class="modal-card">
            <h2
              class="mb-3 heading color-inherit"
              style="font-size: 26px; line-height: 32px"
            >
              Are you sure you want to quit the onboarding?
            </h2>
            <b-button
              variant="outline-info"
              pill
              block
              @click="window.location.href = process.env.VUE_APP_SITE_URL"
            >
              Yes, I'm Sure
            </b-button>
            <b-button
              variant="info"
              pill
              block
              @click="showRedirectModal = false"
            >
              Cancel
            </b-button>
          </div>
        </template>
      </b-modal>

      <!-- Logout Modal -->
      <b-modal
        v-model="showLogoutModal"
        size="md"
        hide-header
        hide-footer
        centered
        :content-class="isOnboardingRedesign ? `tw-bg-white` : `dark-bg`"
        no-close-on-backgdrop
        no-close-on-esc
        no-stacking
      >
        <b-row
          v-if="!isOnboardingRedesign"
          class="mb-6"
        >
          <b-col cols="12">
            <div class="icon-logo dark"></div>
          </b-col>
        </b-row>
        <div v-if="isOnboardingRedesign">
          <h2
            class="color-inherit tw-py-4 tw-text-center"
            style="font-size: 26px;"
          >
            Are you sure you want to log out?
          </h2>

          <div class="tw-max-w-[300px] tw-mx-auto">
            <b-button
              variant="info"
              class="slight-rounded"
              pill
              block
              @click="logout"
            >
              Yes, I'm Sure
            </b-button>
            <b-button
              variant="info"
              class="slight-rounded tw-bg-transparent tw-text-[#312849] hover:tw-bg-[#f5f3fc] tw-border-[#312849]"
              pill
              block
              @click="showLogoutModal = false"
            >
              Cancel
            </b-button>
          </div>
        </div>
        <div
          v-else
          class="modal-card"
        >
          <h2
            class="mb-3 heading color-inherit"
            style="font-size: 26px; line-height: 32px"
          >
            Are you sure you want to log out?
          </h2>

          <b-button
            variant="outline-info"
            class="slight-rounded"
            pill
            block
            @click="logout"
          >
            Yes, I'm Sure
          </b-button>
          <b-button
            variant="info"
            class="slight-rounded"
            pill
            block
            @click="showLogoutModal = false"
          >
            Cancel
          </b-button>
        </div>
      </b-modal>
    </b-container>

    <portal-target
      name="onboarding-cta-footer"
    />
    <portal-target
      name="intermediary-footer"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

// services
import { OnboardingService } from '@/services/onboarding.service';
import { AuthService } from '@/services/auth.service';

// mixins
import { fsaHsaPromoMixin } from '@/mixins/fsaHsaPromo';
import { onboardingCtaFooter } from '@/mixins/onboardingCtaFooter';
import analyticsMixin from '@/mixins/analytics';

// components
import IntermediaryLoader from '../components/onboarding/loaders/IntermediaryLoader.vue';
import FsaHsaStoreBanner from '@/components/partials/FsaHsaStoreBanner.vue';

export default {
  components: {
    IntermediaryLoader,
    FsaHsaStoreBanner
  },
  mixins: [fsaHsaPromoMixin, onboardingCtaFooter, analyticsMixin],
  beforeRouteUpdate(to, from, next) {
    if (from.matched[0].name == 'onboarding' && to.name == 'onboarding') {
      next(false);
    } else {
      next();
    }
  },
  data() {
    return {
      userid: '',
      intermediaryLoader: false,
      loaderType: 1,
      intermediaryLoaderText:
        'As we age, our hormones decrease, and we have loads of symptoms related to those changes. Winona can help relieve those symptoms.',
      messageType: 'HIPAA',
      showRedirectModal: false,
      showLogoutModal: false,
      exiting: false,
      onboardingstep: ''
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    title: function () {
      return this.$route.meta.title;
    },
  },
  watch: {
    isOnboardingRedesign: {
      handler(val) {
        if (val) {
          document.documentElement.classList.add('redesign');
        } else {
          document.documentElement.classList.remove('redesign');
        }
      },
      immediate: true
    },
    async intermediaryLoader(val) {
      if (val) {
        await this.$_analytics_track(
          'Onboarding Screen Viewed',
          {
            customerId: this.onboardingPatient.id,
            screen: '4.9-A',
            onboardingflow: this.onboardingPatient.onboardingflow,
            firstname: this.onboardingPatient.firstname,
            lastname: this.onboardingPatient.lastname
          },
        );
      } else {
        await this.$_analytics_track(
          'Onboarding Screen Viewed',
          {
            customerId: this.onboardingPatient.id,
            screen: '5.1-A',
            onboardingflow: this.onboardingPatient.onboardingflow,
            firstname: this.onboardingPatient.firstname,
            lastname: this.onboardingPatient.lastname
          },
        );
      }
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventExit);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventExit);
  },
  async mounted () {
    this.$_onboardingCtaFooter_init()
    await this.$store.dispatch('setUTMS', this.$route.query);
    if (this.$route.query.flow && this.$route.query.flow == 'b') {
      $cookies.set('onboardingflow', 'flowB');
    }

    await this.fbqTrack();
  },
  methods: {
    async fbqTrack() {
      try {
        // FB Pixel Tracking
        fbq('init', '348219289912097');
        // fbq("track", "PageView");
        const pageViewBody = { userid: this.userid };
        OnboardingService.onboardingEvent('PageView', pageViewBody);
        fbq('trackCustom', 'OnboardingStarted', {
          ...(await this.$store.dispatch('getFBQParams')),
        });
      } catch (err) {
        console.log(err);
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.documentElement;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    showLoader(loaderType, messageType = null) {
      if (loaderType) {
        this.loaderType = loaderType;
        if (messageType) {
          this.messageType = messageType;
          this.intermediaryLoader = true;
          this.toggleBodyClass('addClass', 'stopScroll');
        } else {
          this.intermediaryLoader = true;
          window.setTimeout(() => {
            this.intermediaryLoader = false;
            this.toggleBodyClass('removeClass', 'stopScroll');
          }, 5000);
        }
      }
    },
    hideLoader() {
      this.intermediaryLoader = false;
      this.toggleBodyClass('removeClass', 'stopScroll');
    },
    async logout() {
      this.$store.dispatch('socket/closeSocketConnection');
      this.$_fsaHsaPromo_resetBanner();
      await AuthService.logout();
    },
    // * Step override for prev() calls
    setOnboardingStep(step) {
      this.onboardingstep = step;
    },
    setExiting(val) {
      this.exiting = val;
    },
    preventExit(event) {
      if (this.exiting || this.$route.path != '/eligibility') return;
      event.preventDefault();
      event.returnValue = '';
    },
    redirectToMarketing() {
      window.location.href = process.env.VUE_APP_WEBSITE_URL;
    }
  },
};
</script>

<style scoped>
::v-deep .btn {
  min-width: 200px;
}

/* $primary */
::v-deep .heading {
  color: #1a6a72;
}
</style>

<style lang="scss" scoped>
.modal-card {
  .btn.btn-outline-info {
    border-color: #cdfcb1;
    background-color: transparent;
    color: #cdfcb1;

    &:active {
      background-color: transparent;
      border-color: #cdfcb1;
      box-shadow: 0 0 0 0.15rem rgba(#cdfcb1, 0.5);
    }

    &:focus {
      box-shadow: 0 0 0 0.15rem rgba(#cdfcb1, 0.5);
    }
  }
}

.getting-started {
  background-color: $body-bg;
}

html:not(.redesign) {
  .navbar {
    background-color: $quaternary;
  }
}

.redesign {
  .navbar {
    box-shadow: 8px 6px 23.3px 0px #2D2B2B0D;
  }
}

.navbar {
  height: 80px;
  border: 0;
  // background-color: $quaternary;

  @include media-breakpoint-down(md) {
    height: auto;
  }
  @include media-breakpoint-down(lg) {
    padding: 10px;
  }

  @include media-breakpoint-up(xxl) {
    height: 80px * $scale-font;
  }
}

.c-logo {
  @include media-breakpoint-down(md) {
    margin: 0;
    padding-left: 1rem;
  }
}

.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.logout {
  @include media-breakpoint-up(lg) {
    top: 0;
    padding: 7px 10px;
    font-size: 0.8rem;
    min-width: 40px !important;
    right: 2.5rem;
    img {
      height: 19px;
    }
  }

  @include media-breakpoint-up(xxl) {
    top: 0;
    margin-top: 0 !important;
    margin-right: 2rem !important;
    padding: 7px * $scale-font 10px * $scale-font;
    font-size: 0.8rem * $scale-font;
    right: 2.5rem * $scale-font;

    img {
      height: 19px * $scale-font;
    }
  }
  position: relative;
  min-width: 40px !important;
  background-color: #fbfff9;
  letter-spacing: 1px;
  text-transform: capitalize;
  box-shadow: 0px 4px 6px #d0e7c2;
  border-radius: 15px;
  font-weight: normal;
  top: -4px;
}

.loader-text {
  font-size: 1.2rem;

  @include media-breakpoint-up(xxl) {
    font-size: 1.2rem * $scale-font;
  }
}

.loader-sub-text {
  font-size: 1rem !important;

  @include media-breakpoint-up(xxl) {
    font-size: 1rem * $scale-font !important;
  }
}

</style>
